var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM9.9999 4C7.79077 4 5.99991 5.79086 5.99991 8C5.99991 10.2091 7.79077 12 9.9999 12C12.209 12 13.9999 10.2091 13.9999 8C13.9999 5.79086 12.209 4 9.9999 4ZM15.1115 13.9974C15.8693 14.4854 15.8323 15.5491 15.1422 16.1288C13.7517 17.2966 11.9581 18 10.0001 18C8.0551 18 6.27215 17.3059 4.88556 16.1518C4.18931 15.5723 4.15242 14.5032 4.91351 14.012C5.15044 13.8591 5.40846 13.7251 5.68849 13.6097C6.81516 13.1452 8.2542 13 10 13C11.7546 13 13.2018 13.1359 14.3314 13.5954C14.6136 13.7102 14.8734 13.8441 15.1115 13.9974Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro1);
export default __webpack_public_path__ + "static/media/pro1.e9f026cc51ca26eb60fd3e8f8a494b04.svg";
export { ForwardRef as ReactComponent };